import React from 'react';
import { string } from 'prop-types';

import styles from './Icon.module.scss';

Icon.propTypes = {
  className: string,
  glyph: string.isRequired,
};

Icon.defaultProps = {
  className: '',
};

// STOP! Want to extend SVG icon component layout?
// Please be sure you wand to change all site icons
// since this generic component is used by Webpack
// svg-sprite-loader and it's applied to all svg imports
export default function Icon({ className, glyph, ...restProps }) {
  return (
    <span className={`${styles.root} ${className}`}>
      <svg {...restProps}>
        <use xlinkHref={`#${glyph}`} />
      </svg>
    </span>
  );
}



// WEBPACK FOOTER //
// ./src/components/Icon/Icon.js